import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

const STATS = [
  { value: "24+", label: "部精选影视", icon: "ri-film-line" },
  { value: "100%", label: "中文字幕覆盖", icon: "ri-translate-2" },
  { value: "2 大", label: "内容分类", icon: "ri-layout-grid-line" },
  { value: "7×24", label: "在线观看", icon: "ri-time-line" },
];

export default function IntroSection() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-primary-950 p-6 md:p-10">
      <div className="grid gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-information-line text-sm" />
            </span>
            关于我们
          </span>
          <h2 className="mt-4 text-xl font-medium text-background-50 md:text-2xl">
            {site.name}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-primary-100/85">
            {site.description}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-primary-100/85">
            我们持续整理日韩电视剧与电影资源，按类型、地区、年份与评分分类呈现，方便中文观众快速找到想看的作品。播放区域目前为界面演示，正式播放接口正在筹备中。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm text-primary-800 transition-colors hover:bg-background-100"
            >
              了解站点详情
            </Link>
            <Link
              to="/search"
              className="whitespace-nowrap rounded-md border border-primary-100/40 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-background-50/10"
            >
              开始搜索影片
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-primary-800/60 bg-primary-900/50 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <p className="mt-3 text-xl font-medium text-background-50">{stat.value}</p>
              <p className="mt-1 text-xs text-primary-200/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}